import { cloneData } from './cloneData';
import { eachFigures } from './eachFigures';
export function clearData(data) {
    data = cloneData(data);
    eachFigures(function (indexes) {
        var count = indexes.filter(function (i) { return data[i].value; }).length;
        if (count === 9)
            indexes.forEach(function (i) { return (data[i].clear = true); });
    });
    for (var i = 0; i < 81; i++) {
        if (data[i].clear) {
            data[i].clear = false;
            data[i].value = 0;
        }
    }
    return data;
}
